import { GtmService } from '~/src/services/web-analytics.service';
import { getAnalyticsEventData } from '~/src/helpers/web-analytics-events-data.helper';
import {
    WebAnalyticsActionGroupEnum,
    WebAnalyticsEventActionEnum,
    WebAnalyticsEventCategoryEnum,
    WebAnalyticsEventEnum,
} from '~/src/models/enums/web-analytics.enum';

export const onSendAddCommentAndFileAnalytics = (eventCategory: WebAnalyticsEventCategoryEnum) => {
    GtmService.send(
        getAnalyticsEventData({
            eventAction: WebAnalyticsEventActionEnum.elementClick,
            eventLabel: 'dobavit_kommentarii/prikrepit_fail',
            eventContent: null,
            event: WebAnalyticsEventEnum.vntEvent,
            eventCategory: eventCategory,
            actionGroup: WebAnalyticsActionGroupEnum.interactions,
            productName: null,
        }),
    );
};

export const onSendCommentTextAnalytics = (eventCategory: WebAnalyticsEventCategoryEnum) => {
    GtmService.send(
        getAnalyticsEventData({
            eventAction: WebAnalyticsEventActionEnum.formAdd,
            eventLabel: 'kommentarii',
            eventContent: null,
            event: WebAnalyticsEventEnum.vntEvent,
            eventCategory: eventCategory,
            actionGroup: WebAnalyticsActionGroupEnum.interactions,
            productName: null,
        }),
    );
};

export const onUploadFileAnalytics = (eventCategory: WebAnalyticsEventCategoryEnum) => {
    GtmService.send(
        getAnalyticsEventData({
            eventAction: WebAnalyticsEventActionEnum.formAdd,
            eventLabel: 'prikrepite_fail',
            eventContent: null,
            event: WebAnalyticsEventEnum.vntEvent,
            eventCategory: eventCategory,
            actionGroup: WebAnalyticsActionGroupEnum.interactions,
            productName: null,
        }),
    );
};
